import './styles.scss'
import React from 'react'
import { t } from 'i18next'
import { COFFEE_CAFES } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import MetaTagsComponent from 'Components/MetaTagsComponent'

const CoffeeCafes = () => {
  const userDetails = getLocalUserDetails()

  return (
    <div className={`coffee-cafes-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
      <MetaTagsComponent title={t('COFFEE_CAFE_TITLE')} description={t('COFFEE_CAFE_DESCRIPTION')} keywords={t('COFFEE_CAFE_KEYWORDS')} url="https://coffeeweb.com/coffeeweb" h1Content={t('COFFEE_CAFE_H1_CONTENT')} />

      <video controls className="coffee-cafes-image" autoPlay loop playsInline>
        <source src={COFFEE_CAFES.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default CoffeeCafes
